@let item = link();
@switch (true) {
@case ('href' in item) {
<a [href]="item.href" mat-ripple>
  <ng-container *ngTemplateOutlet="wrapper"></ng-container>
</a>
}
@case ('route' in item) {
<a [routerLink]="item.route" mat-ripple>
  <ng-container *ngTemplateOutlet="wrapper"></ng-container>
</a>
}
@case ('click' in item) {
<!-- eslint-disable-next-line 
    @angular-eslint/template/click-events-have-key-events -->
<a (click)="item.click()" tabindex="0" mat-ripple>
  <ng-container *ngTemplateOutlet="wrapper"></ng-container>
</a>
}
}

<ng-template #wrapper>
  <div class="wrapper">
    <span>{{item.label}}</span>
    @if(item.icons?.end; as icon) {
    <fa-icon [icon]="icon" class="item-icon-end"></fa-icon>
    }
  </div>
</ng-template>